import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from './tab.js'

import './tabs.scss'

class Tabs extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeTab: this.props.children[0].props.label,
    }
  }

  onClickTabItem = tab => {
    this.setState({ activeTab: tab })
  }

  render() {
    const {
      onClickTabItem,
      props: { children },
      state: { activeTab },
    } = this

    return (
      <div className="tabs">
        <div className="tabs__header">
          {children
            .filter(child => child)
            .map(child => {
              const { label, disabled, hide } = child.props

              return (
                <Tab
                  activeTab={activeTab}
                  key={label}
                  label={label}
                  disabled={disabled}
                  hide={hide}
                  onClick={onClickTabItem}
                  onKeyDown={onClickTabItem}
                  role="tab"
                />
              )
            })}
        </div>
        <div className="tabs__content">
          {children
            .filter(child => child)
            .map(child => {
              if (child.props.label !== activeTab) return undefined
              return child.props.children
            })}
        </div>
      </div>
    )
  }
}

export default Tabs
